<!--
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-05-30 16:59:37
 * @LastEditTime: 2022-06-14 09:29:03
-->
<template>
    <Common>
      <template slot="cd">
          <CdRegister />
      </template>
      <template slot="sz">
          <SzRegister />
      </template>
      <template slot="hf">
          <HfRegister />
      </template>
    </Common>
</template>

<script>
import CdRegister from "@/components/hospitalRegister/cdRegister"
import SzRegister from "@/components/hospitalRegister/szRegister"
import HfRegister from "@/components/hospitalRegister/hfRegister"
export default{
  components:{
    CdRegister,
    SzRegister,
    HfRegister
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>

</style>